// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + ".bundle.min.js?h=" + "c251e49ac02db172" + "";
};